export default __webpack_public_path__ + "static/media/fseries.2d35775c.png";